import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    searchString: '',
};

const searchStringSlice = createSlice({
    name: 'searchString',
    initialState,
    reducers: {
        setSearchString: (state, action) => {
            state.searchString = action.payload;
        },
    },
});

export const { setSearchString } = searchStringSlice.actions;
export default searchStringSlice.reducer;
